import { render, staticRenderFns } from "./tsi-header.vue?vue&type=template&id=5516de52"
import script from "./tsi-header.vue?vue&type=script&lang=js"
export * from "./tsi-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports